<template>
    <div class="typo">

        <div class="campaign-info-promotion">
            <div class="campaign-info-promotion-center">
                <span>
                    <strong>Nr karty</strong> Klienta otrzymasz na podany adres
                    E‑mail<br>
                    dopiero <strong>po zakończeniu rejestracji przez wszystkich</strong>
                    z&nbsp;Twojej firmy.
                </span>
            </div>
        </div>
        <p>
            Pozostań z nami w kontakcie i otrzymuj kupony rabatowe na zakupy
            oraz indywidualnie dobrane promocje.
        </p>
        <!--<p>
            <img src="@/assets/images/baner_zgody_o.png" alt="-20% Rabatu" />
        </p>-->
        <p>
            Wyrażenie zgody jest dobrowolne i można ją wycofać w każdym momencie.
            <a @click.prevent="showDetails">przeczytaj całość</a>
        </p>
        <transition name="fade">
            <FormPricacyPolicy v-if="details" />
        </transition>
    </div>
</template>

<script>
import FormPricacyPolicy from '@/components/form/FormPrivacyPolicy'
export default {
    name: "CampaignInfo",
    components: {FormPricacyPolicy},
    data () {
        return {
            details: false
        }
    },
    created() {
        console.log('created pp')
    },
    methods: {
        showDetails () {
            console.log('toggle details')
            this.details = !this.details
        }
    }
}
</script>

<style lang="scss">
    @import 'src/assets/scss/_variables/color';
    @import 'src/assets/scss/_variables/fonts';

    .campaign-info-promotion {
        display: flex;
        align-items: center;
        background: $color-secondary;
        color: $color-primary;
        padding: 20px 2px;
        border-radius: 7px;
        width: 100%;
        font-size: 1.6rem;
        margin-bottom: 20px;

        br {
            @media (max-width: 480px) {
                display: none;
            }
        }

        &-center {
            position: relative;
            padding: 0 26px;
            font-size: 16px;
            line-height: 20px;
        }

        &-left {
            position: relative;
            padding: 0 26px;
            font-size: 16px;
            line-height: 20px;
            // font-weight: 600;
            width: calc(100% - 100px);

            strong {
                font-weight: 600;
            }

            &:after {
                content: '';
                display: block;
                position: absolute;
                right: 0;
                top: 0;
                background: $color-primary;
                width: 1px;
                height: 100%;
            }
         }

        &-right {
            padding: 0 23px;
            position: relative;
            font-size: 44px;
            font-weight: $font-weight-black;
            width: 100px;
            text-align: center;

            &:before {
                content: '';
                display: block;
                position: absolute;
                left: -1px;
                top: 5px;
                bottom: 5px;
                background: $color-primary;
                width: 1px;
            }
        }
    }
</style>
